export const reducirNombre = ({nombre, largo = 16}) => {

    if (nombre.length > largo) {

        return nombre.substring(0, largo - 3) + '...';

    } else {
        return nombre
    }

}